import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/sidebar/sidebar";
import AppHeader from "../components/header/header";

const { Header, Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [pageTitle, setPageTitle] = useState("Giải đấu");
  useEffect(() => {
    const updateLayout = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 900);
    };
    updateLayout();
    window.addEventListener("resize", updateLayout);
    return () => window.removeEventListener("resize", updateLayout);
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        onChangeTitle={setPageTitle}
      />

      <Layout style={{ flexDirection: "column" }}>
        <AppHeader
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          title={pageTitle}
        />

        <Content
          style={{
            flex: 1,
            margin: isMobile ? "16px" : "1px",
            marginLeft: collapsed ? "80px" : "200px",
            padding: "16px",
            background: "#fff",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
